import { InfoCircleOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '../../../../redux/hooks.ts'
import { selectThemeStyle } from '../../../../features/setting/setting.slice.ts'
import Tooltip from 'antd/es/tooltip/index'
import { useIsMobile } from '../../../../common/hooks/use-is-mobile.ts'

export const ReturnPctDependentHeaderComponent = () => {
  const { t } = useTranslation()
  const themeStyle = useAppSelector(selectThemeStyle)
  const isMobile = useIsMobile()

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: themeStyle.marginXXS,
        width: '100%',
      }}
    >
      <span>{t('overall_ranking.ranking_table.columns.return_pct')}</span>
      {!isMobile && (
        <Tooltip
          title={t('overall_ranking.ranking_table.tooltip.return_pct')}
        >
          <InfoCircleOutlined
            style={{
              color: themeStyle.colorIcon,
              marginLeft: themeStyle.marginXS,
              cursor: 'pointer',
            }}
          />
        </Tooltip>
      )}
    </div>
  )
}
